
module.exports = {
    MotivosTipoMoneda: [
        {"motivo": 601,"moneda": "UTM","articulo": "Art75 DFL5/17"},
        {"motivo": 701,"moneda": "UTM","articulo": "Art 31 inc 5 DFL 2/17"},
        {"motivo": 702,"moneda": "UTM","articulo": "Art 31 inc 6 DFL 2/17"},
        {"motivo": 703,"moneda": "UTM","articulo": "Art34 DFL N°2-2017"},
        {"motivo": 704,"moneda": "UTM","articulo": "Art136inc1 DFL2/17"},
        {"motivo": 707,"moneda": "UTM","articulo": "Art38 inc1 DFL2/17"},
        {"motivo": 708,"moneda": "UTM","articulo": "Art38 inc3 DFL2/17"},
        {"motivo": 709,"moneda": "UTM","articulo": "Art.155 DFL 2-2017"},
        {"motivo": 801,"moneda": "UTM","articulo": "Art61 DFL N°4-2017"},
        {"motivo": 802,"moneda": "UTM","articulo": "Art22 inc2 DFL4/17"},
        {"motivo": 803,"moneda": "CLP","articulo": "Art39 DFL N°4-2017"},
        {"motivo": 804,"moneda": "UTM","articulo": "Art41 DFL N°4-2017"},
        {"motivo": 805,"moneda": "UTM","articulo": "Art67 DFL N°4-2017"},
        {"motivo": 806,"moneda": "UTM","articulo": "Art26 inc9 DFL4/17"},
        {"motivo": 807,"moneda": "UTM","articulo": "Art49 DFL N°4-2017"},
        {"motivo": 808,"moneda": "UTM","articulo": "Art. 22 Ley 20.080"},
        {"motivo": 901,"moneda": "UTM","articulo": "Art10 DFL N°3-2017"},
        {"motivo": 902,"moneda": "UTM","articulo": "Art10 y 24 DFL3/17"},
        {"motivo": 903,"moneda": "UTM","articulo": "Tero Art. 24 DFL 3/17"},
        {"motivo": 904,"moneda": "UF","articulo": "Cdto. Art10DFL3/17"},
        {"motivo": 905,"moneda": "UF","articulo": "Alc. Art10 DFL3/17"},
        {"motivo": 906,"moneda": "UF","articulo": "CORE Art10 DFL3/17"},
        {"motivo": 907,"moneda": "UF","articulo": "Dip. Art10 DFL3/17"},
        {"motivo": 908,"moneda": "UF","articulo": "Sen. Art10 DFL3/17"},
        {"motivo": 909,"moneda": "UF","articulo": "Pdte. Art10DFL3/17"},
        {"motivo": 910,"moneda": "UF","articulo": "Cjal. Art10DFL3/17"},
        {"motivo": 911,"moneda": "UF","articulo": "Alc. Art10 DFL3/17"},
        {"motivo": 912,"moneda": "UF","articulo": "CORE Art10 DFL3/17"},
        {"motivo": 913,"moneda": "UF","articulo": "Dip. Art 10 DLF 3/17"},
        {"motivo": 914,"moneda": "UF","articulo": "Sen. Art 10 DLF 3/17"},
        {"motivo": 916,"moneda": "UF","articulo": "Pdte. Art 10 DLF 3/17"},
        {"motivo": 917,"moneda": "UF","articulo": "Art10 inc9 DFL3/17"},
        {"motivo": 918,"moneda": "UF","articulo": "Art 10 inc 9 DLF 3/17"},
        {"motivo": 919,"moneda": "UF","articulo": "Cjal. Art 10 inc 7 DFL 3/17"},
        {"motivo": 920,"moneda": "UF","articulo": "Alc. Art 10 inc 7 DFL 3/17"},
        {"motivo": 921,"moneda": "UF","articulo": "CORE Art 10 inc 7 DFL 3/17"},
        {"motivo": 923,"moneda": "UF","articulo": "Dip. Art 10 inc 7 DFL 3/17"},
        {"motivo": 924,"moneda": "UF","articulo": "Sen. Art 10 inc 7 DFL 3/17"},
        {"motivo": 925,"moneda": "UF","articulo": "Pdte.Art10inc6DFL3"},
        {"motivo": 926,"moneda": "UF","articulo": "Art 5 DFL N°3-2017"},
        {"motivo": 927,"moneda": "UTM","articulo": "Art 10 inc 7 DFL 3/17"},
        {"motivo": 928,"moneda": "UF","articulo": "Art20 inc1 DFL3/17"},
        {"motivo": 929,"moneda": "UTM","articulo": "Art19 inc1 DFL3/17"},
        {"motivo": 930,"moneda": "UF","articulo": "Art20 inc3 DFL3/17"},
        {"motivo": 931,"moneda": "UTM","articulo": "Tero Art19inc1DFL3"},
        {"motivo": 932,"moneda": "UTM","articulo": "Art 27 DFL 3/17"},
        {"motivo": 933,"moneda": "CLP","articulo": "Art27 y 30 DFL3/17"},
        {"motivo": 934,"moneda": "CLP","articulo": "Art30 inc1 DFL3/17"},
        {"motivo": 935,"moneda": "CLP","articulo": "Art30 inc3 DFL3/17"},
        {"motivo": 936,"moneda": "CLP","articulo": "Art29 inc3 DFL3/17"},
        {"motivo": 937,"moneda": "CLP","articulo": "Art50 inc4 DFL3/17"},
        {"motivo": 938,"moneda": "UTM","articulo": "Art2 inc2 DFL3/17"},
        {"motivo": 939,"moneda": "UTM","articulo": "Art37 inc2 DFL3/17"},
        {"motivo": 940,"moneda": "UF","articulo": "Art. 6 DFL 3/2017"},
        {"motivo": 941,"moneda": "UTM","articulo": "Art 3 DFL N°3-2017"},
        {"motivo": 942,"moneda": "UF","articulo": "Cjal.Art4y5DFL3/17"},
        {"motivo": 943,"moneda": "UF","articulo": "Alc. Art4y5DFL3/17"},
        {"motivo": 944,"moneda": "UF","articulo": "CORE Art4y5DFL3/17"},
        {"motivo": 945,"moneda": "UF","articulo": "Dip. Art4y5DFL3/17"},
        {"motivo": 946,"moneda": "UF","articulo": "Sen. Art4y5DFL3/17"},
        {"motivo": 947,"moneda": "UF","articulo": "Pdte.Art4y5DFL3/17"},
        {"motivo": 948,"moneda": "UF","articulo": "Art12 DFL N°3-2017"},
        {"motivo": 949,"moneda": "UTM","articulo": "Art 15 inc 3 DFL 3/17"},
        {"motivo": 950,"moneda": "UTM","articulo": "Art15 inc3 DFL3/17"},
        {"motivo": 951,"moneda": "UTM","articulo": "Art 25 DFL 3-2017"},
        {"motivo": 952,"moneda": "UTM","articulo": "Art 46 DFL 3-2017"},
        {"motivo": 953,"moneda": "UTM","articulo": "Art 47 DFL 3-2017"},
        {"motivo": 954,"moneda": "CLP","articulo": "Art50 inc4 DFL3/17"},
        {"motivo": 955,"moneda": "UTM","articulo": "AdmElect Art 47 DFL 3/17"},
        {"motivo": 956,"moneda": "UTM","articulo": "AdmElect Art29DFL3"},
        {"motivo": 957,"moneda": "UTM","articulo": "Art. 37 c) DFL3/17"},
        {"motivo": 958,"moneda": "UTM","articulo": "Art39 DFL N°3-2017"},
        {"motivo": 959,"moneda": "UTM","articulo": "Art45 DFL N°3-2017"},
        {"motivo": 960,"moneda": "UTM","articulo": "Art29 inc5 DFL3/17"},
        {"motivo": 961,"moneda": "CLP","articulo": "Art50 inc3 DFL N3" }
    ]
}